import { render, staticRenderFns } from "./TiBuilder.vue?vue&type=template&id=1a3a8480&scoped=true"
import script from "./TiBuilder.vue?vue&type=script&lang=js"
export * from "./TiBuilder.vue?vue&type=script&lang=js"
import style0 from "./TiBuilder.vue?vue&type=style&index=0&id=1a3a8480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3a8480",
  null
  
)

export default component.exports